<mat-accordion>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 0" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">1</span>
          <span class="title">Bid Details</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11353.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Bid Name*</span>
        <span class="value">{{bidDetail?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11353.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Building Specifications</span>
        <span class="value">{{bidDetail?.building_specifications}}</span>
      </div>
    </div>
    @if (!isEdit) {
      <div class="wrapper">
        <img src="../../../../assets/img/general_icons/Group 11355.svg" alt="icon" class="icon">
        <div class="wrap">
          <span class="label">Customer*</span>
          <span class="value">{{bidDetail?.customer?.customer_id?.name}}</span>
        </div>
      </div>
    }
    @if (!isEdit) {
      <div class="wrapper">
        <img src="../../../../assets/img/general_icons/Group 11356.svg" alt="icon" class="icon">
        <div class="wrap">
          <span class="label">Contact*</span>
          <span class="value">{{bidDetail?.customer?.contact_id?.name}}</span>
        </div>
      </div>
    }
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7886.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Bid Due Date*</span>
        <span class="value">{{bidDetail?.due_date_at | date}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7886.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Bid Due Time*</span>
        <span class="value">{{bidDetail?.startTime | date:'h:mm a'}}</span>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 1" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">2</span>
          <span class="title">Scopes</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7925.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Scopes*</span>
        <span class="value">{{coreService.arrayObjectToString(scopesStage?.scopes)}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7931.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Sales Stage*</span>
        <span class="value">{{scopesStage?.stage_id?.name}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7929.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Bid Type</span>
        <span class="value">{{coreService.arrayObjectToString(scopesStage?.bid_types)}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7927.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Source</span>
        <span class="value">{{scopesStage?.source_id?.name}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7927.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Probability</span>
        <span class="value">{{scopesStage?.probability}}%</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7927.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Description</span>
        <span class="value" style="word-wrap:break-word">{{scopesStage?.description}}</span>
      </div>
    </div>


  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 2" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">3</span>
          <span class="title">Assignment</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7933.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Project Manager *</span>
        <span class="value">{{assignment?.project_manager_id?.full_name}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7933.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Assign To</span>
        <span class="value">{{assignment?.assigned_to_id?.full_name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7935.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Estimator</span>
        <span class="value">{{assignment?.estimator_id?.full_name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7931.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Sales Rep*</span>
        <span class="value">{{assignment?.sales_rep_id?.full_name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7931.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Secondary Sales Rep</span>
        <span class="value">{{assignment?.secondary_sales_rep_id?.full_name}}</span>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel  [expanded]="this.step?.event?.selectedIndex-1 === 3" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">4</span>
          <span class="title">Jobsite Address</span>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/location_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Job Site* </span>
        <span class="value">{{jobsiteAddressDetail?.jobsite_id?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/location_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 1*</span>
        <span class="value">{{jobsiteAddressDetail?.jobsiteAddress?.address_line_1}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/home_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 2</span>
        <span class="value">{{jobsiteAddressDetail?.jobsiteAddress?.address_line_2}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/city_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">City*</span>
        <span class="value">{{jobsiteAddressDetail?.jobsiteAddress?.city}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/state_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">State*</span>
        <span class="value">{{jobsiteAddressDetail?.jobsiteAddress?.state_id?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/zipcode_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Zip Code*</span>
        <span class="value">{{jobsiteAddressDetail?.jobsiteAddress?.zipcode}}</span>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
